<!--Delete modal
<div class="modal fade" id="deletemodal" tabindex="-1" role="dialog" >
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">-->
<app-loadconfirm *ngIf="showSpinner" [text]="'projectdelete.deleteloader'| trans " [icon]="'delete'"></app-loadconfirm>
<div class="modal-header">
  <h5 class="modal-title" id="exampleModalLabel">{{ 'projectdelete.header' | trans }}</h5>
  <button #closeconfirm type="button" class="close" data-dismiss="modal" aria-label="Close">
    <span>&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col">
      <div *ngIf="!showmsg" class="alert alert-danger">
        {{ 'projectdelete.alert' | trans }}
      </div>
      <!--<div *ngIf="showmsg" class="alert text-center alert-success">
        {{ 'projectdelete.deletemsg' | trans }}
      </div>---->
      <p *ngIf="!showmsg" class="text-center mb-2 text-muted">{{ 'projectdelete.confirm' | trans }}</p>
    </div>
  </div>
  <div *ngIf="!showmsg" class="row">
    <div class="col">
      <button data-dismiss="modal" class="btn-save float-left">
        <h6 class="btn-save-text">{{ 'projectdelete.cancel' | trans }}</h6>
      </button>
    </div>
    <div class="col">
      <button (click)="deleteProject()" class="btn-close float-right">
        <h6 class="btn-save-text">{{ 'projectdelete.confirmdelete' | trans }}</h6>
      </button>
    </div>
  </div>
</div>

<!-- </div>
  </div>
</div> -->